import { z } from "zod";
import { AnswerKeySchema, FieldValueSchema } from "../form-engine/answers.js";
// What a note's display-only fields show, by answer key (ADR-039 decision 11):
// the record's value as the field's control takes it, or null while the record
// holds none. Never the binding's example.
export const DisplayOnlyValueSchema = z.object({
    value: FieldValueSchema.nullable(),
});
// What a note's fields hold, by answer key (ADR-039 decision 11): its answers,
// each changeable field among them at the record's value, and beside them what
// each display-only field shows, apart because the page sends the answers back
// and never a display-only value. A note's responses carry its own; before a
// session has a note, a template's starting values are what its fields start
// from.
export const SessionNoteValuesSchema = z.object({
    answers: z.record(AnswerKeySchema, FieldValueSchema),
    displayOnlyValues: z.record(AnswerKeySchema, DisplayOnlyValueSchema),
});
